export default "__VITE_ASSET__7621d46d__"